import { render, staticRenderFns } from "./membre-color-picker.vue?vue&type=template&id=52500d25&scoped=true"
import script from "./membre-color-picker.vue?vue&type=script&lang=js"
export * from "./membre-color-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52500d25",
  null
  
)

export default component.exports